<header class="app-topbar">
    <div class="container-fluid topbar-menu">
        <div class="d-flex align-items-center gap-2">
            <!-- Topbar Brand Logo -->
            <div class="logo-topbar">
                <!-- Logo light -->
                <a href="javascript:void(0)" class="logo-light">
                    <span class="logo-lg">
                        <img src="assets/images/logo.svg" alt="logo" />
                    </span>
                    <span class="logo-sm">
                        <img src="assets/images/logo-sm.svg" alt="small logo" />
                    </span>
                </a>

                <!-- Logo Dark -->
                <a href="javascript:void(0)" class="logo-dark">
                    <span class="logo-lg">
                        <img src="assets/images/logo.svg" alt="dark logo" />
                    </span>
                    <span class="logo-sm">
                        <img src="assets/images/logo-sm.svg" alt="small logo" />
                    </span>
                </a>
            </div>

            <!-- Sidebar Menu Toggle Button -->
            <!-- <button class="sidenav-toggle-button btn btn-primary btn-icon">
                        <i class="ri ri-menu-line"></i>
                    </button> -->
            <button class="sidenav-toggle-button btn btn-primary btn-icon" (click)="toggleSidebar()">
                <i class="ri ri-menu-line"></i>
            </button>
            <!-- Horizontal Menu Toggle Button -->
            <button class="topnav-toggle-button px-2" data-bs-toggle="collapse" data-bs-target="#topnav-menu">
                <i class="ri ri-menu-line"></i>
            </button>

            <div id="search-box-adornment" class="app-search-pill input-group d-none d-xl-flex">
                <input type="search" class="form-control topbar-search" name="search" placeholder="Quick Search..." />
                <button class="btn btn-dark btn-icon" type="button">
                    <i class="ri ri-search-line"></i>
                </button>
            </div>

            <div id="loot-box" class="topbar-item d-none">
                <div class="dropdown">
                    <a href="#!" class="topbar-link btn shadow-none btn-link dropdown-toggle drop-arrow-none px-2"
                        data-bs-toggle="dropdown">
                        Quick links
                        <i class="ri ri-arrow-down-s-line ms-1"></i>
                    </a>
                    <div class="dropdown-menu">
                        <!-- My Profile -->
                        <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-user-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Secret Identity</span>
                        </a>

                        <!-- Settings -->
                        <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-settings-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Control Panel</span>
                        </a>

                        <!-- Support -->
                        <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-customer-service-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Help Squad</span>
                        </a>
                    </div>
                    <!-- end dropdown-menu-->
                </div>

            </div>

            <!-- <div id="megamenu-columns" class="topbar-item d-none d-md-flex">
                <div class="dropdown">
                    <button class="topbar-link btn fw-medium btn-link dropdown-toggle drop-arrow-none px-2"
                        data-bs-toggle="dropdown" type="button" aria-haspopup="false" aria-expanded="false">
                        Mega Menu
                        <i class="ri ri-arrow-down-s-line ms-1"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-xxl p-0">
                        <div class="h-100" style="max-height: 380px" data-simplebar="">
                            <div class="row g-0">
                                
                                <div class="col-md-4">
                                    <div class="p-2">
                                        <h5 class="mb-1 fw-semibold fs-sm dropdown-header">Dashboard &amp;
                                            Analytics</h5>
                                        <ul class="list-unstyled megamenu-list">
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Sales Dashboard
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Marketing Dashboard
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Finance Overview
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    User Analytics
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Traffic Insights
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                
                                <div class="col-md-4">
                                    <div class="p-2">
                                        <h5 class="mb-1 fw-semibold fs-sm dropdown-header">Project Management
                                        </h5>
                                        <ul class="list-unstyled megamenu-list">
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i class="ri ri-subtract-line align-middle me-1 text-muted"></i>
                                                    Kanban Workflow
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i class="ri ri-subtract-line align-middle me-1 text-muted"></i>
                                                    Project Timeline
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i class="ri ri-subtract-line align-middle me-1 text-muted"></i>
                                                    Task Management
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i class="ri ri-subtract-line align-middle me-1 text-muted"></i>
                                                    Team Members
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i class="ri ri-subtract-line align-middle me-1 text-muted"></i>
                                                    Assignments
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                               
                                <div class="col-md-4">
                                    <div class="p-2 bg-light bg-opacity-50">
                                        <h5 class="mb-1 fw-semibold fs-sm dropdown-header">User Management</h5>
                                        <ul class="list-unstyled megamenu-list">
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    User Profiles
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Access Control
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Security Settings
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    User Groups
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" class="dropdown-item">
                                                    <i
                                                        class="ri ri-arrow-right-s-line align-middle me-1 text-muted"></i>
                                                    Authentication
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div> -->
        </div>

        <div class="d-flex align-items-center gap-2">
            <!-- <div class="topbar-item d-none d-sm-flex">
                <button class="topbar-link" data-bs-toggle="offcanvas" data-bs-target="#theme-settings-offcanvas"
                    type="button">
                    <i class="ri ri-settings-2-line topbar-link-icon"></i>
                </button>
            </div> -->

            <!-- <div id="theme-toggler" class="topbar-item d-none d-sm-flex">
                <button class="topbar-link" id="light-dark-mode" type="button">
                    <i class="ri ri-moon-line topbar-link-icon mode-light-moon"></i>
                    <i class="ri ri-sun-line topbar-link-icon mode-light-sun"></i>
                </button>
            </div> -->

            <div class="topbar-item d-sm-flex">
                <div class="active-plan">
                    <i class="fas fa-crown"></i>
                    <span>
                        <small>PLAN</small>
                        {{ activePlanName }}
                    </span>
                </div>
                <span>
                    <a href="javascript:void(0)" class="me-2 btn btn-dark" (click)="openRechargeModel(rechargeModel)">
                        Recharge
                    </a>
                </span>
                <span>
                    <img src="assets/images/svg/walleticon.svg" width="32" class="me-1">
                    <!-- <a class="wallet-wrapper"><span class="wallet-blance fw-bold">₹ {{walletBalanceAmt}}</span></a>
                    <a href="javascript:void(0)" class="me-1" (click)="walletBalance()"><i
                            class="ri ri-reset-left-line"></i></a> -->
                    <a class="wallet-wrapper" href="javascript:void(0)" [ngbTooltip]="walletTooltip" placement="bottom"
                        container="body">

                        <span class="wallet-blance fw-bold">
                            ₹ {{ formatAmount(walletBalanceAmt) }}
                        </span>
                    </a>

                    <a *ngIf="!isWalletRefreshHidden" href="javascript:void(0)" class="me-1" (click)="walletBalance()">

                        <i class="ri ri-reset-left-line"></i>
                    </a>
                </span>

                <ng-template #walletTooltip>
                    <div>
                        ₹ {{ walletBalanceAmt | number:'1.2-2' }}
                    </div>
                </ng-template>


            </div>



            <!-- <div id="notification-dropdown-people" class="topbar-item">
                <div class="dropdown">
                    <button class="topbar-link dropdown-toggle drop-arrow-none" data-bs-toggle="dropdown" type="button"
                        data-bs-auto-close="outside" aria-haspopup="false" aria-expanded="false">
                        <i class="ri ri-notification-3-line topbar-link-icon animate-ring"></i>
                        <span class="badge text-bg-danger badge-circle topbar-badge">5</span>
                    </button>

                    <div class="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg">
                        <div class="px-3 py-2 border-bottom">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="m-0 fs-md fw-semibold">Notifications</h6>
                                </div>
                                <div class="col text-end">
                                    <a href="#!" class="badge badge-soft-success badge-label py-1">07
                                        Notifications</a>
                                </div>
                            </div>
                        </div>

                        <div style="max-height: 300px" data-simplebar="">
                         
                            <div class="dropdown-item notification-item py-2 text-wrap" id="message-1">
                                <span class="d-flex align-items-center gap-3">
                                    <span class="flex-shrink-0 position-relative">
                                        <img src="assets/images/users/user-4.jpg" class="avatar-md rounded-circle"
                                            alt="User Avatar" />
                                        <span class="position-absolute rounded-pill bg-success notification-badge">
                                            <i class="ri ri-notification-3-line align-middle"></i>
                                            <span class="visually-hidden">unread notification</span>
                                        </span>
                                    </span>
                                    <span class="flex-grow-1 text-muted">
                                        <span class="fw-medium text-body">Emily Johnson</span>
                                        commented on a task in
                                        <span class="fw-medium text-body">Design Sprint</span>
                                        <br />
                                        <span class="fs-xs">12 minutes ago</span>
                                    </span>
                                    <button type="button"
                                        class="flex-shrink-0 text-muted btn btn-link p-0 position-absolute end-0 me-2 d-none noti-close-btn"
                                        data-dismissible="#message-1">
                                        <i class="ri ri-close-circle-line fs-xxl"></i>
                                    </button>
                                </span>
                            </div>

                            
                            <div class="dropdown-item notification-item py-2 text-wrap" id="message-2">
                                <span class="d-flex align-items-center gap-3">
                                    <span class="flex-shrink-0 position-relative">
                                        <img src="assets/images/users/user-5.jpg" class="avatar-md rounded-circle"
                                            alt="User Avatar" />
                                        <span class="position-absolute rounded-pill bg-info notification-badge">
                                            <i class="ri ri-upload-cloud-2-line align-middle"></i>
                                            <span class="visually-hidden">upload notification</span>
                                        </span>
                                    </span>
                                    <span class="flex-grow-1 text-muted">
                                        <span class="fw-medium text-body">Michael Lee</span>
                                        uploaded files to
                                        <span class="fw-medium text-body">Marketing Assets</span>
                                        <br />
                                        <span class="fs-xs">25 minutes ago</span>
                                    </span>
                                    <button type="button"
                                        class="flex-shrink-0 text-muted btn btn-link p-0 position-absolute end-0 me-2 d-none noti-close-btn"
                                        data-dismissible="#message-2">
                                        <i class="ri ri-close-circle-line fs-xxl"></i>
                                    </button>
                                </span>
                            </div>

   
                        </div>

                    
                        <a href="javascript:void(0);"
                            class="dropdown-item text-center text-reset text-decoration-underline link-offset-2 fw-bold notify-item border-top border-light py-2">Read
                            All Messages</a>
                    </div>
                    
                </div>
            </div> -->

            <!-- <div id="fullscreen-toggler" class="topbar-item d-none d-sm-flex">
                        <button class="topbar-link" type="button" data-toggle="fullscreen">
                            <i class="ri ri-fullscreen-line topbar-link-icon"></i>
                            <i class="ri ri-fullscreen-exit-line topbar-link-icon d-none"></i>
                        </button>
                    </div> -->

            <div id="simple-user-dropdown" class="topbar-item nav-user">
                <div class="dropdown">
                    <a class="topbar-link dropdown-toggle drop-arrow-none px-2" data-bs-toggle="dropdown" href="#!"
                        aria-haspopup="false" aria-expanded="false">
                        <!-- <img src="assets/images/users/user-1.jpg" width="32" class="rounded-circle me-lg-2 d-flex"
                            alt="user-image" /> -->
                        <div class="avatar_circle me-lg-2">
                            {{ user?.customer?.firstname?.charAt(0)?.toUpperCase() }}
                            <!-- {{ user?.customer?.lastname?.charAt(0)?.toUpperCase() }} -->
                        </div>
                        <div class="d-lg-flex align-items-center gap-1 d-none">
                            <h5 class="my-0">{{user?.customer?.firstname}} </h5>
                            <i class="ri ri-arrow-down-s-line align-middle"></i>
                        </div>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                        <!-- Header -->
                        <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome back!</h6>
                        </div>

                        <!-- My Profile -->
                        <a href="javascript:void(0);" class="dropdown-item" (click)="openProfile()">
                            <i class="ri ri-user-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Profile</span>
                        </a>

                        <!-- Notifications -->
                        <!-- <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-notification-3-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Notifications</span>
                        </a> -->

                        <!-- Wallet -->
                        <!-- <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-bank-card-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">
                                Balance:
                                <span class="fw-semibold">$985.25</span>
                            </span>
                        </a> -->

                        <!-- Settings -->
                        <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-settings-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Account Settings</span>
                        </a>

                        <!-- Support -->
                        <a href="javascript:void(0);" class="dropdown-item">
                            <i class="ri ri-customer-service-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Support Center</span>
                        </a>

                        <!-- Divider -->
                        <div class="dropdown-divider"></div>

                        <!-- Lock -->
                        <!-- <a href="auth-lock-screen.html" class="dropdown-item">
                            <i class="ri ri-lock-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Lock Screen</span>
                        </a> -->

                        <!-- Logout -->
                        <a href="javascript:void(0);" class="dropdown-item text-danger fw-semibold"
                            (click)="onLogout()">
                            <i class="ri ri-logout-box-line me-1 fs-lg align-middle"></i>
                            <span class="align-middle">Log Out</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<!-- <ng-template #rechargeModel>

    <div class="dialog-header d-flex justify-content-between align-items-center px-3 py-2 text-black">
        <h4 class="mb-0 fw-semibold">Wallet Recharge</h4>
        <button type="button" class="btn-close" (click)="closeModal()">
        </button>
    </div>

    <div class="dialog-body px-3 py-3">

        <div class="mb-2">
            <h5 class="mb-0">
                Current Balance :
                <span class="fw-bold" [ngClass]="walletBalanceAmt < 0 ? 'text-danger' : 'text-success'">
                    ₹ {{ walletBalanceAmt }}
                </span>
            </h5>
        </div>

        <form [formGroup]="rechargeForm">
            <div class="mb-3">

                <div class="badge bg-light text-dark rounded-pill px-3 py-2 mb-2">
                    Select Amount for Quick Recharge
                </div>

                <div class="d-flex flex-wrap gap-2">
                    <div *ngFor="let amount of quickAmounts" class="btn amount_wrapper"
                        [class.active]="selectedAmount === amount" (click)="selectAmount(amount)">
                        {{ shortAMT(amount) }}
                    </div>
                </div>

            </div>
            <div class="mb-2">

                <div class="d-flex justify-content-between align-items-center mb-2">

                    <label class="form-label fw-semibold mb-0">
                        Enter Amount
                    </label>

                    <small class="text-muted">
                        ( Min. recharge amount is ₹ {{minRechargeAmount}} )
                    </small>

                </div>

                <input type="number" class="form-control" formControlName="amount" placeholder="Enter Recharge Amount">
                <div class="text-danger mt-1"
                    *ngIf="rechargeForm.get('amount')?.touched && rechargeForm.get('amount')?.errors">
                    <span *ngIf="rechargeForm.get('amount')?.hasError('required')">
                        Amount is required.
                    </span>

                    <span *ngIf="rechargeForm.get('amount')?.hasError('min')">
                        Minimum recharge amount is ₹{{ minRechargeAmount }}.
                    </span>
                </div>

            </div>

            <div class="form-check mb-4">

                <input class="form-check-input" type="checkbox" formControlName="acceptCharges" id="iagreeaccept">

                <label for="iagreeaccept" class="form-check-label">

                    I agree to pay convenience charges by payment gateway.

                     <a href="javascript:void(0)" class="text-decoration-none ms-1">
                        Click here
                    </a>

                    to check the charges.

                </label>
                <div class="text-danger mt-1"
                    *ngIf="rechargeForm.get('acceptCharges')?.touched && rechargeForm.get('acceptCharges')?.errors">
                    <span *ngIf="rechargeForm.get('acceptCharges')?.hasError('required')">
                        Please accept the convenience charges.
                    </span>


                </div>

            </div>



            <div class="text-end">
                <button class="btn btn-link" (click)="resetForm()">

                    Reset

                </button>

                <button type="submit" class="btn proceed_btn" (click)="proceedToPay()">

                    Proceed to Pay <i class="fas fa-arrow-right ms-2"></i>

                </button>
            </div>

        </form>

        <div class="border-top mt-2">

            <h6 class="fw-semibold my-2 ">
                Bank Details (For NEFT / RTGS)
            </h6>

            <div class="bank-row" *ngFor="let item of bankDetailsList">

                <span class="bank-label">
                    {{ item.label }} :
                </span>

                <div class="bank-value">

                    <span>{{ item.value }}</span>

                    <i *ngIf="item.copy" class="far fa-copy text-muted ms-1 copy_icon " (click)="copyText(item.value)">
                    </i>

                </div>

            </div>


        </div>

    </div>


</ng-template> -->

<ng-template #rechargeModel>

    <!-- ================= HEADER ================= -->
    <div class="dialog-header d-flex justify-content-between align-items-center px-3 py-2 text-black">

        <h4 class="mb-0 fw-semibold">
            Wallet Recharge
        </h4>

        <button type="button" class="btn-close" (click)="closeModal()">
        </button>

    </div>


    <!-- ================= BODY ================= -->
    <div class="dialog-body px-3 py-3">

        <div class="row">


            <div class="col-lg-8 col-md-8 col-12">



                <!-- Current Balance -->
                <div class="mb-1">

                    <h5 class="mb-0">
                        Current Balance :

                        <span class="fw-bold" [ngClass]="walletBalanceAmt < 0 ? 'text-danger' : 'text-success'">

                            ₹ {{ walletBalanceAmt }}

                        </span>
                    </h5>

                </div>


                <form [formGroup]="rechargeForm">

                    <!-- ================= QUICK RECHARGE ================= -->
                    <div class="mb-2">

                        <div class="badge bg-light text-dark rounded-pill px-3 py-2 mb-2">

                            <i class="fas fa-tag me-1"></i>

                            Select Amount for Quick Recharge

                        </div>


                        <div class="d-flex flex-wrap gap-2">

                            <div *ngFor="let amount of quickAmounts" class="btn amount_wrapper"
                                [class.active]="selectedAmount === amount" (click)="selectAmount(amount)">

                                {{ shortAMT(amount) }}

                            </div>

                        </div>

                    </div>


                    <!-- ================= AMOUNT ================= -->
                    <div class="mb-1">

                        <div class="d-flex justify-content-between align-items-center mb-2">

                            <label class="form-label fw-semibold mb-0">
                                Enter Amount
                            </label>

                            <small class="text-muted">
                                ( Min. recharge amount is ₹ {{ minRechargeAmount }} )
                            </small>

                        </div>


                        <input type="number" class="form-control" formControlName="amount"
                            placeholder="Enter Recharge Amount">


                        <div class="text-danger mt-1" *ngIf="rechargeForm.get('amount')?.touched &&
                                       rechargeForm.get('amount')?.errors">

                            <span *ngIf="rechargeForm.get('amount')?.hasError('required')">
                                Amount is required.
                            </span>

                            <span *ngIf="rechargeForm.get('amount')?.hasError('min')">
                                Minimum recharge amount is ₹{{ minRechargeAmount }}.
                            </span>

                        </div>

                    </div>


                    <!-- ================= CHARGES ================= -->
                    <div class="form-check mb-2">

                        <input class="form-check-input" type="checkbox" formControlName="acceptCharges"
                            id="iagreeaccept">


                        <label for="iagreeaccept" class="form-check-label">

                            I agree to pay convenience charges by payment gateway.

                        </label>


                        <div class="text-danger mt-1" *ngIf="rechargeForm.get('acceptCharges')?.touched &&
                                       rechargeForm.get('acceptCharges')?.errors">

                            <span *ngIf="rechargeForm.get('acceptCharges')?.hasError('required')">

                                Please accept the convenience charges.

                            </span>

                        </div>

                    </div>


                    <!-- ================= BUTTONS ================= -->
                    <div class="text-end mb-1">

                        <button type="button" class="btn btn-link" (click)="resetForm()">

                            Reset

                        </button>


                        <button type="button" class="btn proceed_btn" (click)="proceedToPay()">

                            Proceed to Pay

                            <i class="fas fa-arrow-right ms-2"></i>

                        </button>

                    </div>

                </form>


                <!-- ================= BANK DETAILS ================= -->
                <div class="border-top pt-2">

                    <h6 class="fw-semibold my-2">
                        Bank Details (For NEFT / RTGS)
                    </h6>


                    <div class="bank-row" *ngFor="let item of bankDetailsList">

                        <span class="bank-label">
                            {{ item.label }} :
                        </span>


                        <div class="bank-value">

                            <span>
                                {{ item.value }}
                            </span>


                            <i *ngIf="item.copy" class="far fa-copy text-muted ms-1 copy_icon"
                                (click)="copyText(item.value)">
                            </i>

                        </div>

                    </div>

                </div>

                <!-- </div> -->

            </div>


            <!-- ================= RIGHT SIDE - PAYTM ================= -->
            <div class="col-lg-4 col-md-4 col-12 paytm-side">

                <div class="paytm-content">

                    <!-- Company Name -->
                    <div class="paytm-company-name">
                        <p class="mb-0">Fastglobe Technologies</p>
                        <p class="mb-0">Private Limited</p>
                    </div>

                    <!-- Paytm QR -->
                    <div class="paytm-qr-wrapper">

                        <img src="assets/images/fastglobe-paytm.webp" alt="Paytm UPI QR" class="paytm-qr-image">

                    </div>

                    <!-- Scan Text -->
                    <div class="scan-text">
                        <p class="mb-0">Scan with any UPI app</p>
                    </div>

                    <!-- Payment Instruction -->
                    <div class="payment-help-text">

                        <p class="mb-0">Scan and share the payment</p>

                        <p class="mb-0">
                            screenshot to
                            <a href="mailto:support@fastglobe.in">
                                support&#64;fastglobe.in
                            </a>
                             or with
                        </p>

                        <p class="mb-0">
                            your Sales POC along with your customer ID
                        </p>

                    </div>

                </div>

            </div>

        </div>

    </div>

</ng-template>
<ng-template #paymentSuccessModal>
    <div class="dialog-body px-4 py-4 text-center">
        <div class="mb-3">
            <div class="success-icon-circle mx-auto mb-3">
                <i class="ri ri-checkbox-circle-fill text-green" style="font-size: 64px;"></i>
            </div>
            <h4 class="fw-bold text-green mb-1">Payment Successful!</h4>
            <p class="text-muted mb-0">Your wallet has been recharged successfully.</p>
        </div>

        <div class="payment-detail-box rounded p-3 mb-4 text-start">
            <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Amount Paid</span>
                <span class="fw-bold text-dark">₹ {{paymentResult?.amount}}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">New Wallet Balance</span>
                <span class="fw-bold text-green">₹ {{paymentResult?.wallet_balance}}</span>
            </div>
            <div class="d-flex justify-content-between">
                <span class="text-muted">Transaction ID</span>
                <span class="fw-semibold text-dark">#{{paymentResult?.transaction_id}}</span>
            </div>
        </div>

        <button class="btn proceed_btn w-100" (click)="closeModal()">Close</button>
    </div>
</ng-template>

<ng-template #paymentFailureModal>
    <div class="dialog-body px-4 py-4 text-center">
        <div class="mb-3">
            <div class="mx-auto mb-3">
                <i class="ri ri-close-circle-fill text-danger" style="font-size: 64px;"></i>
            </div>
            <h4 class="fw-bold text-danger mb-1">Payment Failed!</h4>
            <p class="text-muted mb-0">{{ paymentError }}</p>
        </div>
        <div class="payment-detail-box rounded p-3 mb-4 text-start">
            <div class="d-flex align-items-start gap-2">
                <i class="ri ri-information-line text-warning mt-1"></i>
                <small class="text-muted">Agar aapke account se amount deduct hua hai to 5-7 working days mein refund ho
                    jayega. Support ke liye contact karein.</small>
            </div>
        </div>
        <button class="btn btn-danger w-100" (click)="closeModal()">Close</button>
    </div>
</ng-template>